// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/create-portfolio/app/css/app.css
// module id = 806
// module chunks = 0